import {
  popupStore,
  userInfoStore,
  roundInfoStore, userSettingsStore,
} from '@pascal/pascal-core/shared/core/store';

import {
  parseQuery,
  DefaultQueryParams, applicationStore, tableBetHistoryStore,
} from '@pascal/pascal-core';
import { gameStore } from '../store/gameStore';
import { initialTimerDuration, timerDuration } from '../../core/constants/gameConstants';
import { configStore } from '../store/configStore';
import { toJS } from 'mobx';
import { resultStore } from '../store/resultStore';
import { BetResponseCodes } from '../../enums/BetResponseCodes';
import { ValidationType } from '../../enums/ValidationType';
import { notificationService } from '../services/NotificationService';
import { betStatus } from '../../enums/BetStatus';
import { soundService } from '../services/SoundService';
import { playerService } from '../services/PlayerService';
import { gameLiveConnection } from './gameLiveConnection';

class GameService {

  timeOutForReset = null;
  demoRoundId = 1

  onGetInitialStateResult({
    rate,
    results,
    quickBets,
    balance,
    precision,
    roundInfo,
    currentBets,
    maxWinLimit,
    currencyCode,
    additionalInfo,
    spinInfo,
  }) {
    configStore.setRate(rate);
    configStore.setPrecision(precision);
    userInfoStore.setCurrencyCode(currencyCode);
    gameStore.setQuickBets(quickBets.reverse());
    gameStore.setAmountByIndex(1);
    gameStore.setOdds(toJS(additionalInfo));
    userInfoStore.setBalance(balance);
    if (spinInfo) {
      const { id, amount, second, spinData: { step, matrix, matrixType } } = spinInfo;
      if (step > 0) {
        gameStore.setResultReportState(true);
        gameStore.setTime(second - 1 || initialTimerDuration); // -1 for possible mistake between front and back
        gameStore.startTimer();
        soundService.timer();
      } else {
        gameStore.setDoSpinState(true);
      }

      roundInfoStore.setRoundId(id);
      gameStore.setMatrixType(matrixType);
      gameStore.setAmount(amount);

      resultStore.setBetResult({
        matrix,
        amount,
        step,
        status: betStatus.pending,
      });
    }
    if (popupStore.reconnect) {
      setTimeout(() => {
        popupStore.toggleReconnect(false);
      }, 1000);
    }
  };

  onDoSpinResult(data) {
    gameStore.setIsGamePadDisabled(false);

    if(applicationStore.isDemo && userInfoStore.balance < gameStore.amount) {
      return notificationService.setResponseNotification(BetResponseCodes[ValidationType.NotEnoughMoney]);
    }

    notificationService.setResponseNotification(BetResponseCodes[data.responseCode]);

    if (data.responseCode !== ValidationType.Success) return

    if (applicationStore.isDemo) {
      userInfoStore.setDemoBalance(userInfoStore.balance - gameStore.amount);
      roundInfoStore.setRoundId(gameStore.demoRoundId);
      gameStore.upgradeDemoSpinId();
    } else {
      roundInfoStore.setRoundId(data.spinId);
      userInfoStore.setBalance(data.balance);
    }

    // soundService.start();
    gameStore.setDoSpinState(true);
    resultStore.setBetResult(data);
  };

  onResultReportResult(data) {
    if (data.responseCode !== ValidationType.Success) return

    gameStore.setDoSpinState(false);
    gameStore.setResultReportState(true);
    resultStore.setBetResult({ ...data, matrix: data.mineFieldStates });

    if (data.status === betStatus.pending) {
      soundService.correctStep();
      gameStore.setTime(timerDuration);
      gameStore.startTimer();
      soundService.timer();
      return;
    }

    if (data.status === betStatus.lose) {
      gameStore.setIsGamePadDisabled(true);
      soundService.bomb();
      gameStore.clearTimeInterval();
      gameStore.setTime(timerDuration);
      if(!applicationStore.isDemo){
        setTimeout(() => {
          tableBetHistoryStore.handleBetHistoryUpdate();
        },1000)
      }
      gameService.resetResults(500);
    }

    if (data.status === betStatus.completed) {
      gameService.onCashOutResult(data, true);
    }
  };


  onCashOutResult(data, completed = false) {
    if (data.responseCode !== ValidationType.Success) {
      notificationService.setResponseNotification(BetResponseCodes[data.responseCode]);
      return gameService.handleReconnecting();
    }
    completed ? soundService.levelCompleted() : soundService.cashOut();
    gameStore.setIsGamePadDisabled(true);
    resultStore.setCashOutResult(data);
    gameStore.clearTimeInterval();
    gameStore.setTime(timerDuration);
    if (applicationStore.isDemo) {
      userInfoStore.setDemoBalance(userInfoStore.balance + data.winAmount);
    } else {
      setTimeout(() => {
        tableBetHistoryStore.handleBetHistoryUpdate();
      },1000)
      playerService.updateBalance();

    }
    gameService.resetResults(1000);
  };

  resetResults(timeOut) {
    clearTimeout(this.timeOutForReset);
    if (timeOut) {
      this.timeOutForReset = setTimeout(() => {
        if(!applicationStore.isDemo) playerService.getBalance()
        gameStore.resetResults();
        soundService.stopCashOut();
        resultStore.resetResults();
      }, timeOut);
    } else {
      if(!applicationStore.isDemo) playerService.getBalance()
      gameStore.resetResults();
      soundService.stopCashOut();
      resultStore.resetResults();
    }
  }

  onGameOpen(data, connection) {
    if (data.connectionId !== connection?.connectionId) {
      if(!popupStore.reconnect) {
        popupStore.onConnectionError(true);
      }
      gameLiveConnection.sendClose();
    }
  }

  handleReconnecting() {
    gameService.resetResults();
    popupStore.toggleReconnect(true);
    gameLiveConnection.sendGetInitialState();
  };

  handleReconnected() {
    gameService.resetResults(0);
    gameLiveConnection.sendGetInitialState();
  };

  //
  // handleConnectionError() {
  //   // loadingStore.updateLoading({ isPixiLoaded: false });
  //   popupStore.onConnectionError(true);
  //   popupStore.open({ name: PopUps.ConnectionError });
  // };

  handleConnectionStatus() {
    const query = parseQuery(window.location.search);
    const lang = query[DefaultQueryParams.Culture] || AppDefaultValuesEnum.LANGUAGE;
    const partnerId = query[DefaultQueryParams.PartnerId];
  }

  handlePing(data) {
    this.isReceivePong = !!data;
    return data;
  }
}

export const gameService = new GameService();
